import React, { useMemo } from "react";
import flatten from "lodash/flatten";
import { FormattedMeterValidationResults } from "../utils/formatMeterValidationResults";
import { AlertBlock } from "../../../components/AlertBlock";

export type ValidationMessagesProps = {
  meterId: string;
  messages?: FormattedMeterValidationResults;
  onMount?: Function;
};
export const ValidationMessages: React.FC<ValidationMessagesProps> = ({
  onMount,
  meterId,
  messages,
}) => {
  const hasAnyErrors = Object.values(messages ?? {}).some(
    (result) => result.hasErrors,
  );
  const tabMessages = messages?.[meterId];

  const errors = useMemo(() => {
    return tabMessages?.errors
      ? flatten(Object.values(tabMessages.errors))
      : undefined;
  }, [tabMessages]);

  const warnings = useMemo(() => {
    return tabMessages?.warnings
      ? flatten(Object.values(tabMessages.warnings))
      : undefined;
  }, [tabMessages]);

  if (errors?.length) {
    // return errors only
    return (
      <AlertBlock
        onMount={onMount}
        list={errors.length > 1}
        isClosable={false}
        variant="error"
        title="We can’t add a reading for this meter."
        messages={errors}
        my={0}
      />
    );
  }

  // return warnings IF there are no errors anywhere in the form
  if (warnings?.length && !hasAnyErrors) {
    return (
      <AlertBlock
        onMount={onMount}
        list={warnings.length > 1}
        isClosable={false}
        variant="info"
        messages={warnings}
        my={0}
      />
    );
  }

  return null;
};
